import VueRouter from "vue-router";
export default container => {
    container.declare("router", ({Vue, settings}) => {
        // inject the VueRouter plugin
        Vue.use(VueRouter);
        return new VueRouter(settings.routes);
    });
};
